import React from 'react';
import PropTypes from 'prop-types';

import { StyledTitle } from './styles';

function Title({ color, center, uppercase, children }) {
  return (
    <StyledTitle color={color} center={center} uppercase={uppercase}>
      {children}
    </StyledTitle>
  );
}

Title.propTypes = {
  color: PropTypes.string.isRequired,
  center: PropTypes.bool,
  uppercase: PropTypes.bool,
  children: PropTypes.string.isRequired,
};

Title.defaultProps = {
  center: false,
  uppercase: false,
};

export default Title;
